//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { faPlay } from '@fortawesome/pro-solid-svg-icons';

export default {
  name: 'EarningsSteps',
  data() {
    return {
      steps: [
        {
          title: this.$t('contributor.intro.steps.register_heading'),
          text: this.$t('contributor.intro.steps.register_text'),
        },
        {
          title: this.$t('cta.upload'),
          text: this.$t('contributor.intro.steps.upload_text'),
        },
        {
          title: this.$t('contributor.intro.steps.earn_heading'),
          text: this.$t('contributor.intro.steps.earn_text'),
        },
      ],
      faPlay,
    };
  },
};
